import { useContext, useEffect } from 'preact/hooks';
import { useField } from 'formik';
import { lightFormat, addMinutes, isToday, getMinutes, startOfToday, isValid, startOfDay, toDate, parseISO, parse, parseJSON } from 'date-fns';

import { ImmediateIcon } from '../ecardsPreact.icons/ImmediateIcon';
import { ClockIcon } from '../ecardsPreact.icons/ClockIcon';
import { Steps } from '../ecardsPreact.constants/steps';
import { ECardGlobalState } from './ECardGlobalState';
import { FormField } from './FormField';
import { DatePickerField } from './DatePickerField';
import { hoursToMinutes } from 'date-fns/esm';
import { FieldError } from './FieldError';
import { GADatalayerEcardCheckout } from '../ecardsPreact.common/App';

export default function ECardStepDelivery(props) {
    const { hidden } = props;
    const [deliveryDateField, deliveryDateMeta, deliveryDateHelpers] = useField('DeliveryDate');
    const [deliveryTimeField, deliveryTimeMeta, deliveryTimeHelpers] = useField('DeliveryTime');

    const { currentStep, isScheduled, isGtmCard, ecardCategory, ecardDesignName } = useContext(ECardGlobalState);

    const isScheduledVal = isScheduled.get;

    useEffect(() => {
        if (isScheduledVal === false) {
            deliveryDateHelpers.setValue(new Date().toJSON());
            deliveryTimeHelpers.setValue('00:00');
        }
    }, [isScheduledVal]);

    useEffect(() => {
        var deliveryDate = parseJSON(deliveryDateField.value);

        if (isScheduledVal === true && isValid(deliveryDate) && isToday(deliveryDate) && deliveryTimeField.value !== undefined) {
            const currentTime = addMinutes(new Date(), 30); // Add 30 mins to give some buffer.
            const timeSpliter = deliveryTimeField.value.split(':');
            const hours = parseInt(timeSpliter[0]);
            const minutes = parseInt(timeSpliter[1]);

            if (hoursToMinutes(hours) + minutes < hoursToMinutes(currentTime.getHours()) + currentTime.getMinutes()) {
                deliveryTimeHelpers.setValue(undefined);
            }
        }
    }, [deliveryDateField.value]);

    const timeOptions = () => {
        const currentDateCheckVal = addMinutes(new Date(), 30);
        const deliveryDateParsedValue = parseJSON(deliveryDateField.value);
        const deliveryDateValue = isValid(deliveryDateParsedValue) ? deliveryDateParsedValue : undefined;
        let time = isValid(deliveryDateField.value) ? startOfDay(deliveryDateField.value) : startOfToday();

        let options = [
            <option key="empty" value="" selected={deliveryTimeField.value === undefined}>
                Select a time
            </option>,
        ];
        for (let i = 0; i < 48; i += 1) {
            const isDisabled = deliveryDateValue !== undefined && isToday(deliveryDateValue) && time < currentDateCheckVal;

            if (isDisabled === false) {
                options.push(
                    <option key={i} value={lightFormat(time, 'HH:mm')}>
                        {lightFormat(time, 'HH:mm')}
                    </option>
                );
            }
            time = addMinutes(time, 30);
        }

        return options;
    };

    const deliveryError = isScheduledVal === undefined && (deliveryDateMeta.error || deliveryTimeMeta.error) ? 'Please select a delivery option' : '';

    return (
        <section class="ecard-form__section ecard-form__section--delivery" hidden={hidden} aria-labelledby="delivery-step-head">
            <header class="ecard-form__header">
                <p class="ecard-form__step-count">Step 2 of {isGtmCard ? 3 : 4}</p>
                <h1 class="ecard-form__title text-form-h1 text-blue" id="delivery-step-head">
                    When would you like it delivered?
                </h1>
            </header>

            <div class="double-col-grid">
                <button
                    class={`selector${isScheduledVal === false ? ' selector--active' : ''}`}
                    type="button"
                    onClick={() => {
                        isScheduled.set(false);
                        if (isGtmCard === false) {
                            GADatalayerEcardCheckout(Steps.DonationSelect, ecardCategory, ecardDesignName);
                            currentStep.set(Steps.DonationSelect);
                        }
                    }}
                >
                    <ImmediateIcon class="selector__icon" />
                    <span>Immediate</span>
                </button>

                <button
                    class={`selector${isScheduledVal === true ? ' selector--active' : ''}`}
                    type="button"
                    onClick={() => {
                        isScheduled.set(true);
                    }}
                >
                    <ClockIcon class="selector__icon" />
                    <span>Scheduled</span>
                </button>
            </div>

            <FieldError error={deliveryError} touched={deliveryDateMeta.touched || deliveryTimeMeta.touched} />

            {isScheduledVal === true && (
                <div class={`double-col-grid`}>
                    <DatePickerField name="DeliveryDate" label="Scheduled delivery date" placeholder="DD/MM/YYYY" required />
                    <FormField type="select" name="DeliveryTime" label="Scheduled delivery time" placeholder="Select a delivery time" required>
                        {timeOptions()}
                    </FormField>
                </div>
            )}
        </section>
    );
}
